import React from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import Profile from '../../settings/generalSettings/profile'
import ProfileTab from '../SeetingsSubTabs/ProfileTab'
import SecurityTab from '../SeetingsSubTabs/SecurityTab'
import NotificationsTab from '../SeetingsSubTabs/NotificationsTab'
import CompanyInfo from '../SeetingsSubTabs/CompanyInfo'

const GeneralSettings = () => {
    return (
        <>
            <Tab.Container id="left-tabs-example" defaultActiveKey="profile">
                <Row>
                    <Col sm={3}>
                        <div className='card'>
                            <div className='card-body'>
                                <h5 className='mb-2'>
                                    General Settings
                                </h5>
                                <Nav variant="pills" className="flex-column nav-bg-light">
                                    <Nav.Item>
                                        <Nav.Link eventKey="profile">Profile</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="security">Security</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="notifications">Notifications</Nav.Link>
                                    </Nav.Item>
                                     {/* <Nav.Item>
                                        <Nav.Link eventKey="company-info">Comapny Information</Nav.Link>
                                    </Nav.Item> */}
                                </Nav>
                            </div>
                        </div>
                    </Col>
                    <Col sm={9}>
                        <div className='card'>
                            < div className='card-body'>
                                <Tab.Content>
                                    <Tab.Pane eventKey="profile"><ProfileTab/></Tab.Pane>
                                    <Tab.Pane eventKey="security"><SecurityTab/></Tab.Pane>
                                    <Tab.Pane eventKey="notifications"><NotificationsTab/></Tab.Pane>
                                    <Tab.Pane eventKey="company-info"><CompanyInfo/></Tab.Pane>

                                </Tab.Content>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Tab.Container >
        </>
    )
}

export default GeneralSettings